// noinspection JSVoidFunctionReturnValueUsed

import React from "react";
import { App } from "./layout/app.jsx";
import { isMobile } from "react-device-detect";
import { createRoot } from "react-dom/client";
import GBETNativeInterface from "../libs/gbetnativeinterface.js";
import store from "../redux/store.js";
import { Provider } from "react-redux";
import SubscriptionManagerV3AAPI from "../libs/GBE.SubscriptionManager/gbe.subscriptionManagerV3AAPI.js";
import SubscriptionManagerV3IAPI from "../libs/GBE.SubscriptionManager/gbe.subscriptionManagerV3IAPI.js";
require("./GBEAnalytics.js");
import GECStore from "../flux/GECStore.ts";
import PDPSStore from "../flux/PDPSStore.ts";

window.GBEUtils = com.globalbettingexchange.base;

if (GBEUtils.qs("gbe-profile") !== null) {
    configurationSettings.systemProfile = GBEUtils.qs("gbe-profile");
}
function init() {
    GBEglobal.clientTimeOffsetMS = window.serverData.serverTime.getTime() - new Date().getTime();
    const embedded = window !== top;

    if (embedded) {
        GBEUtils.setCookie("GBE.isLoggedIn", false);
    }

    var controllerLoaded = false;
    var appInitialized = false;

    var myController = new gec.Controller({
        iapiURL: configurationSettings.iapiURL,
        profile: configurationSettings.systemProfile,
        whitelabelDomain: configurationSettings.whitelabelDomain,
        integrationPartnerId: configurationSettings.integrationPartnerId,
        neverCallRefreshArbitrarySessionInformation: true,
        queueTokenProviderURL: configurationSettings.queueTokenProviderURL,
        onLoaded: function () {
            controllerLoaded = true;
            myController.setDefaultValues({
                priceFormat: GBEglobal.priceFormat,
                language: GBEglobal.globalLanguage,
                currency: GBEglobal.currency,
                integrationPartnerId: configurationSettings.integrationPartnerId

            });

            loadGTVs();
        },
        onConnectionLost: function () {
            if (!["sportsbook", "exchange", "multiples", "gameday"].includes(configurationSettings.mode)) {
                return;
            }
            if (window.reconnectStreaming === undefined) {
                console.error("*** Unable to connect to AAPI ***");

            } else {
                window.setTimeout(function () {
                    window.reconnectStreaming();
                }, 1000);

            }

        },
        onSessionExpired: function () {
            function logoutUser() {
                GBEUtils.setCookie("GBE.isLoggedIn", false, null, "None;Secure");
                window.location.replace(configurationSettings.baseUrl);
            }
            window.setTimeout(function () {
                logoutUser();
            }, 5000);

            alert("Your session has expired. Please log in.");
            logoutUser();
        }
    });
    GECStore.setController(myController);

    GBEglobal.isLoggedIn = function isLoggedIn() {
        return GBEUtils.getCookie("GBE.isLoggedIn") === "true";
    };

    GBEglobal.subsriptionManagerSettings = {};

    GBEglobal.checkResponse = function (resp) {
        if (resp.returnCode === 514) {
            GBEUtils.setCookie("GBE.isLoggedIn", false);
            window.location = configurationSettings.webRoot + "";
        }
    };

    GBEglobal.getChannelInformation = function (data, isMultiple) {

        data = "|" + (data || "");
        if (window.telebetDetails !== undefined) {
            data = "|TB-" + window.telebetDetails.telebetUsername + data;
        }
        if (isMultiple) {
            data = "M|" + data;
        }
        return "GEP-" + configurationSettings.mode + "-" + GBETNativeInterface.clientIdentifier + "-" + configurationSettings.globalVersion.replace("/", "") + data;
    };

    GBEglobal.getMultiplesChannelInformation = function (data) {
        return GBEglobal.getChannelInformation(data, true);
    };

    GBEglobal.getClientIdentifier = function () {
        return "getClientIdentifier";
    };
    GBEglobal.logClientEntry = function (params) {
        /*
            1   PunterInteraction This ClientLogEntry logs an explicit action taken by the punter.
            2   ExternalSystemInteraction This ClientLogEntry logs an explicit interaction initiated by an external system (e.g. a containing web page).
            3   ClientApplicationAction This ClientLogEntry logs an action initiated by the client application (e.g. a timed event)
            4   ConfigurationInformation his ClientLogEntry just records configuration information (and not an explicit event).
        */
        //var userInteractionType = (params.systemInteractionType === undefined) ? params.userInteractionType || 1 : undefined;
        const userInteractionType = params.userInteractionType || 1;

        myController.addClientLogEntry({
            clientName: configurationSettings.whitelabelDisplayName + "_WEB_" + (isMobile ? "MOBILE" : "DESKTOP"),
            clientVersion: configurationSettings.globalVersion, //GEP version
            logEntry: params.logEntry,
            eventTime: (!params.eventTime) ? new Date() : params.eventTime,
            eventEndTime: (!params.eventEndTime) ? new Date() : params.eventEndTime,
            clientLogEntryType: 1,
            userInteractionType: userInteractionType, //1=mouse 2 key
            systemInteractionType: 1, //params.systemInteractionType,
            componentName: params.componentName, //left nav, homepage, event card, mode, right nav,
            subcomponentName: params.subcomponentName || params.componentName,
            itemSelected: GUIDs[params.componentName],
            importance: 1,
            entryCode1: params.entryCode1,
            entryCode2: params.entryCode2,
            entryCode3: params.entryCode3,
            entryCode4: params.entryCode4
        });
    };

    function initializeReactApp() {
        if (!controllerLoaded || appInitialized) {
            return;
        }
        appInitialized = true;
        var SubscriptionManager = (myController.isStreamingEnabled) ? SubscriptionManagerV3AAPI.SubscriptionManagerV3AAPI : SubscriptionManagerV3IAPI.SubscriptionManagerV3IAPI;

        var mySubscriptionManager = new SubscriptionManager({
            gecController: myController,
            pushSettings: GBEglobal.settings.pushSettings,
            preferences: GBEglobal.preferences,
            settings: GBEglobal.subsriptionManagerSettings,
            selections: GBEglobal.selections,
            markets: GBEglobal.markets,
            sportsSelections: GBEglobal.sportsSelections,
            clientMode: GBEglobal.mode
        });

        myController.setAnonymousSessionContext({
            channelInformation: GBEglobal.getChannelInformation(),
            clientIdentifier: GBEglobal.getClientIdentifier(),
            language: GBEglobal.globalLanguage,
            currency: GBEglobal.currency,
            priceFormat: GBEglobal.priceFormat,
            callbackOnSuccess: function () {

            },
            callbackOnException: function (resp) {
                console.error(resp);
            }
        });

        if (GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.enabled && GBEglobal.settings.zenDesk.key) {
            const script = document.createElement("script");
            script.src = "https://static.zdassets.com/ekr/snippet.js?key=" + GBEglobal.settings.zenDesk.key;
            script.setAttribute("id", "ze-snippet");
            script.async = true;
            document.body.appendChild(script);
        }

        /* if (GBEglobal.settings["pushAlert"] !== undefined && GBEglobal.settings["pushAlert"].enabled) {
            const id = GBEglobal.settings.pushAlert.id;
            (function (d, t) {
                var g = d.createElement(t),
                    s = d.getElementsByTagName(t)[0];
                g.src = `https://cdn.pushalert.co/integrate_${id}.js`;
                s.parentNode.insertBefore(g, s);
            }(document, "script"));
        }*/

        const root = createRoot(document.getElementById("app"));
        const params = {
            controller: myController,
            config: { mode: GBEglobal.mode, whiteLabel: configurationSettings.whiteLabel, profile: configurationSettings.profile, tab: configurationSettings.tab },
            subscriptionManager: mySubscriptionManager
        };

        //root.render(React.createElement(App, params));


        root.render(
            <Provider store={store}>
                {React.createElement(App, params)}
            </Provider>
        );
    }

    function loadGTVs() {

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        const anchorPagesKey = `gEP.${capitalizeFirstLetter(configurationSettings.mode)}-${configurationSettings.whitelabelDisplayName}-Web.AnchorPages`;


        function processGTVs(response) {
            var revivers = {
                "pollingXSP": function (configValue) {
                    GBEglobal.settings.XSPEnabledMarketsData.pollingXSP = configValue;
                    return configValue;
                },
                "leftNavConfiguration": function (configValue) {
                    if (configValue.todaysEvents) {
                        GBEglobal.todaysEvents = {};
                        var eventClassifierId, i, link;

                        for (i in configValue.todaysEvents) {
                            if (configValue.todaysEvents[i] !== undefined) {
                                for (eventClassifierId in configValue.todaysEvents[i]) {
                                    if (configValue.todaysEvents[i][eventClassifierId] !== undefined) {
                                        link = configValue.todaysEvents[i][eventClassifierId];
                                        link.eventClassifierId = eventClassifierId;
                                        link.inrunning = false;

                                        GBEglobal.todaysEvents[eventClassifierId] = GBEglobal.todaysEvents[eventClassifierId] || [];
                                        GBEglobal.todaysEvents[eventClassifierId].push(link);

                                    }
                                }
                            }
                        }
                        for (i in configValue.todaysIREvents) {
                            if (configValue.todaysIREvents[i] !== undefined) {
                                for (eventClassifierId in configValue.todaysIREvents[i]) {
                                    if (configValue.todaysIREvents[i][eventClassifierId] !== undefined) {
                                        link = configValue.todaysIREvents[i][eventClassifierId];
                                        link.eventClassifierId = eventClassifierId;
                                        link.inrunning = true;

                                        GBEglobal.todaysEvents[eventClassifierId] = GBEglobal.todaysEvents[eventClassifierId] || [];
                                        GBEglobal.todaysEvents[eventClassifierId].push(link);

                                    }
                                }
                            }
                        }
                    }
                    return configValue;
                }
            };
            revivers[configurationSettings.spEnabledMarketsKey] = function (configValue) {
                return configValue.parameters;
            };

            revivers[anchorPagesKey] = function (configValue) {

                GBEglobal.settings.anchorPages = {};
                configValue.forEach(function (anchorPage) {
                    GBEglobal.settings.anchorPages[anchorPage.eid] = anchorPage;
                });

                return configValue;
            };

            var config = { ...configurationSettings };
            config.integrationPartnerId = configurationSettings.integrationPartnerIdForGTVs;

            GBEUtils.processGTVs(response, GBEglobal.settings, config, configurationSettings.profile, revivers);

            // this code allows the querystring to override settings from the appsupport gtv
            if (GBEUtils.qs("gbe-appsupport") === "true") {
                if (GBEglobal.settings.appSupport && GBEglobal.settings.appSupport.enabled) {
                    console.warn(GBEglobal.settings.appSupport);

                    for (var settingKey in GBEglobal.settings.appSupport) {
                        if (settingKey !== "enabled") {
                            var key = settingKey.charAt(0).toLowerCase() + settingKey.slice(1);
                            GBEglobal.settings[key] = GBEglobal.settings.appSupport[key];
                        }

                    }

                }
            }

            GBEglobal.subsriptionManagerSettings.refreshRatesConfiguration = GBEglobal.settings.refreshRatesConfiguration;
            GBEglobal.subsriptionManagerSettings.currentlyLoggedIn = GBEglobal.isLoggedIn();

            // GBEglobal.settings.idleSession.timeoutMinutes = 5;

            if (GBETNativeInterface.isUIWebView && GBEglobal.settings.casinoSettings && GBEglobal.settings.casinoSettings.hideForIOS) {
                configurationSettings.modes = configurationSettings.modes.filter((mode) => mode !== "Casino");
            }
            initializeReactApp();
        }

        if (window.preloadedGTVs !== undefined) {
            processGTVs(window.preloadedGTVs);

            if (GBEglobal.settings.pushPDPS?.enableSubscribeBalance || GBEglobal.settings.pushPDPS?.enableSubscribeOrders) {

                PDPSStore.init({
                    url: GBEglobal.settings.pushPDPS.streamingConnectionDetails.sockURL,
                    integrationPartnerId: configurationSettings.integrationPartnerId,
                    version: {
                        aapiVersion: "2.2",
                        implementationVersion: "2.2"
                    }
                });

            }


        } else {

            myController.listGenericTaggedValues({
                searchStrings: window.gtvNames,
                callbackOnSuccess: function callbackOnSuccess(response) {
                    processGTVs(response);

                },
                callbackOnException: function callbackOnException(resp) {
                    console.error(resp);
                }
            });
        }

    }

    function getUUID() {
        return GBEUtils.createUUID().substr(0, 32);
    }

    var GUIDs = {
        "mainnav": getUUID(),
        "ex_betslip": getUUID(),
        "sb_betslip": getUUID(),
        "currentslip": getUUID(),
        "eventcard": getUUID(),
        "leftnav": getUUID(),
        "application": getUUID()
    };
}

init();